<!-- <div class="w3-col m8 w3-container w3-margin-bottom info-container2 w3-center w3-hover-shadow w3-borderB"> -->
  <div class="mt-3">
    <!-- <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION1'| translate}}</b></h5> -->

    <p-table #table1 class="mainTable1" [value]="canalData" [rows]="5" [paginator]="false" [globalFilterFields]="[
        'SNo',
        'Type',
        'Canal',
        'RD',
        'Village',
        'District',
        'Constituency',
        'CircleName',
        'fromDate',
        'endDate',
        'CurrentStatus'
        ]" [rowHover]="true" sortMode="multiple" responsiveLayout="scroll" [loading]="loading"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 style="color:rgb(22, 21, 21);" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION1'|
              translate}}</b></h5>
          <span class="p-input-icon-left">
            <!-- <i class="pi pi-search"></i> -->
            <input pInputText type="text" (input)="table1.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="SNo">{{'SR_NO'| translate}}
            <!-- <p-columnFilter type="text" field="SNo" display="menu"></p-columnFilter>
            <p-sortIcon field="SNo"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Type">{{'TARGET_BASED'| translate}}
            <!-- <p-columnFilter type="text" field="Type" display="menu"></p-columnFilter>
            <p-sortIcon field="Type"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Canal">{{'CANAL'| translate}}
            <!-- <p-columnFilter type="text" field="Canal" display="menu"></p-columnFilter>
            <p-sortIcon field="Canal"></p-sortIcon> -->
          </th>
          <th pSortableColumn="RD">{{'RD'| translate}}
            <!-- <p-columnFilter type="text" field="RD" display="menu"></p-columnFilter>
            <p-sortIcon field="RD"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Village">{{'VILLAGE'| translate}}
            <!-- <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
            <p-sortIcon field="Village"></p-sortIcon> -->
          </th>
          <th pSortableColumn="District">{{'DISTRICT'| translate}}
            <!-- <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
            <p-sortIcon field="District"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
            <!-- <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
            <p-sortIcon field="Constituency"></p-sortIcon> -->
          </th>
          <th pSortableColumn="CircleName">{{'CIRCLE'| translate}}
            <!-- <p-columnFilter type="text" field="CircleName" display="menu"></p-columnFilter>
            <p-sortIcon field="CircleName"></p-sortIcon> -->
          </th>
          <th>{{'VIEW_OFFICE_ORDER_COPY'| translate}}</th>
          <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
            <p-sortIcon field="fromDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="endDate">{{'END_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
            <p-sortIcon field="endDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="CurrentStatus">{{'CURRENT_STATUS'| translate}}
            <!-- <p-columnFilter type="text" field="CurrentStatus" display="menu"></p-columnFilter>
            <p-sortIcon field="CurrentStatus"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns">
        <tr>
          <td>{{product?.SNo}}</td>
          <td>{{product?.Type}}</td>
          <td>{{product?.Canal}}</td>
          <td>{{product?.RD}}</td>
          <td>{{product?.Village}}</td>
          <td>{{product?.District}}</td>
          <td>{{product?.Constituency}}</td>
          <td>{{product?.CircleName}}</td>
          <td><a *ngIf="product?.DocumentPath" style="cursor: pointer; color: 'blue'" [href]="product?.DocumentPath"
              target="_blank">{{'VIEW_DOC' | translate}}</a></td>
          <td>{{product?.fromDate | date:'mediumDate'}}</td>
          <td>{{product?.endDate | date:'mediumDate'}}</td>
          <td>{{product?.CurrentStatus}}</td>
        </tr>
      </ng-template>
    </p-table>
    <br>
  </div>

  <div>
    <!-- <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION1'| translate}}</b></h5> -->

    <p-table #table12 class="mainTable1" [value]="stpData" [rows]="5" [paginator]="false" [globalFilterFields]="[
        'SNo',
        'Type',
        'Canal',
        'RD',
        'Village',
        'District',
        'Constituency',
        'CircleName',
        'fromDate',
        'endDate',
        'CurrentStatus'
        ]" [rowHover]="true" sortMode="multiple" responsiveLayout="scroll" [loading]="loading"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 style="color:rgb(22, 21, 21)" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION12'|
              translate}}</b></h5>
          <span class="p-input-icon-left">
            <!-- <i class="pi pi-search"></i> -->
            <input pInputText type="text" (input)="table12.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="SNo">{{'SR_NO'| translate}}
            <!-- <p-columnFilter type="text" field="SNo" display="menu"></p-columnFilter>
            <p-sortIcon field="SNo"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Type">{{'TARGET_BASED'| translate}}
            <!-- <p-columnFilter type="text" field="Type" display="menu"></p-columnFilter>
            <p-sortIcon field="Type"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Canal">{{'STP'| translate}}
            <!-- <p-columnFilter type="text" field="Canal" display="menu"></p-columnFilter>
            <p-sortIcon field="Canal"></p-sortIcon> -->
          </th>
          <!-- <th pSortableColumn="RD">{{'RD'| translate}}
            <p-columnFilter type="text" field="RD" display="menu"></p-columnFilter>
            <p-sortIcon field="RD"></p-sortIcon>
          </th> -->
          <th pSortableColumn="Village">{{'VILLAGE'| translate}}
            <!-- <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
            <p-sortIcon field="Village"></p-sortIcon> -->
          </th>
          <th pSortableColumn="District">{{'DISTRICT'| translate}}
            <!-- <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
            <p-sortIcon field="District"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
            <!-- <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
            <p-sortIcon field="Constituency"></p-sortIcon> -->
          </th>
          <th pSortableColumn="CircleName">{{'CIRCLE'| translate}}
            <!-- <p-columnFilter type="text" field="CircleName" display="menu"></p-columnFilter>
            <p-sortIcon field="CircleName"></p-sortIcon> -->
          </th>
          <th>{{'VIEW_OFFICE_ORDER_COPY'| translate}}</th>
          <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
            <p-sortIcon field="fromDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="endDate">{{'END_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
            <p-sortIcon field="endDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="CurrentStatus">{{'CURRENT_STATUS'| translate}}
            <!-- <p-columnFilter type="text" field="CurrentStatus" display="menu"></p-columnFilter>
            <p-sortIcon field="CurrentStatus"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns">
        <tr>
          <td>{{product?.SNo}}</td>
          <td>{{product?.Type}}</td>
          <td>{{product?.Canal}}</td>
          <!-- <td>{{product?.RD}}</td> -->
          <td>{{product?.Village}}</td>
          <td>{{product?.District}}</td>
          <td>{{product?.Constituency}}</td>
          <td>{{product?.CircleName}}</td>
          <td><a *ngIf="product?.DocumentPath" style="cursor: pointer; color: 'blue'" [href]="product?.DocumentPath"
              target="_blank">{{'VIEW_DOC' | translate}}</a></td>
          <td>{{product?.fromDate | date:'mediumDate'}}</td>
          <td>{{product?.endDate | date:'mediumDate'}}</td>
          <td>{{product?.CurrentStatus}}</td>
        </tr>
      </ng-template>
    </p-table>
    <br>
  </div>

  <div>
    <!-- <h5 style="color:rgb(22, 21, 21); background:darkseagreen" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION2'| translate}}</b></h5> -->

    <p-table #table2 class="mainTable1" [value]="overFlowPondData" [rows]="5" [paginator]="false" [globalFilterFields]="[
        'SNo',
        'Type',
        'Name',
        'Village',
        'District',
        'Block',
        'Constituency',
        'Division',
        'fromDate',
        'endDate',
        'CurrentStatus'
        ]" [rowHover]="true" sortMode="multiple" responsiveLayout="scroll" [loading]="loading"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 style="color:rgb(22, 21, 21)" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION2'|
              translate}}</b></h5>
          <span class="p-input-icon-left">
            <!-- <i class="pi pi-search"></i> -->
            <input pInputText type="text" (input)="table2.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="SNo">{{'SR_NO'| translate}}
            <!-- <p-columnFilter type="text" field="SNo" display="menu"></p-columnFilter>
            <p-sortIcon field="SNo"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Type">{{'TARGET_BASED'| translate}}
            <!-- <p-columnFilter type="text" field="Type" display="menu"></p-columnFilter>
            <p-sortIcon field="Type"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Name">{{'NAME'| translate}}
            <!-- <p-columnFilter type="text" field="Name" display="menu"></p-columnFilter>
            <p-sortIcon field="Name"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Village">{{'VILLAGE'| translate}}
            <!-- <p-columnFilter type="text" field="Village" display="menu"></p-columnFilter>
            <p-sortIcon field="Village"></p-sortIcon> -->
          </th>
          <th pSortableColumn="District">{{'DISTRICT'| translate}}
            <!-- <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
            <p-sortIcon field="District"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Block">{{'BLOCK'| translate}}
            <!-- <p-columnFilter type="text" field="Block" display="menu"></p-columnFilter>
            <p-sortIcon field="Block"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Constituency">{{'CONSTITUENCY'| translate}}
            <!-- <p-columnFilter type="text" field="Constituency" display="menu"></p-columnFilter>
            <p-sortIcon field="Constituency"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Division">{{'DIVISION'| translate}}
            <!-- <p-columnFilter type="text" field="Division" display="menu"></p-columnFilter>
            <p-sortIcon field="Division"></p-sortIcon> -->
          </th>
          <th>{{'VIEW_OFFICE_ORDER_COPY'| translate}}</th>
          <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
            <p-sortIcon field="fromDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="endDate">{{'END_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
            <p-sortIcon field="endDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="CurrentStatus">{{'CURRENT_STATUS'| translate}}
            <!-- <p-columnFilter type="text" field="CurrentStatus" display="menu"></p-columnFilter>
            <p-sortIcon field="CurrentStatus"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns">
        <tr>
          <td>{{product?.SNo}}</td>
          <td>{{product?.Type}}</td>
          <td>{{product?.Name}}</td>
          <td>{{product?.Village}}</td>
          <td>{{product?.District}}</td>
          <td>{{product?.Block}}</td>
          <td>{{product?.Constituency}}</td>
          <td>{{product?.Division}}</td>
          <td><a *ngIf="product?.DocumentPath" style="cursor: pointer; color: 'blue'" [href]="product?.DocumentPath"
              target="_blank">{{'VIEW_DOC' | translate}}</a></td>
          <td>{{product?.fromDate | date:'mediumDate'}}</td>
          <td>{{product?.endDate | date:'mediumDate'}}</td>
          <td>{{product?.CurrentStatus}}</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <table class="w3-border" style="border-collapse:separate;">
          <tr>
            <th>{{'SR_NO' | translate}}</th>
            <th>{{'TARGET_BASED' | translate}}</th>
            <th>{{'NAME' | translate}}</th>
            <th>{{'VILLAGE' | translate}}.</th>
            <th>{{'DISTRICT' | translate}}</th>
            <th>{{'BLOCK' | translate}}</th>
            <th>{{'CONSTITUENCY' | translate}}</th>
            <th>{{'DIVISION' | translate}}</th>
            <th>{{'VIEW_OFFICE_ORDER_COPY'| translate}}</th>
            <th>{{'START_DATE'| translate}}</th>
            <th>{{'END_DATE'| translate}}</th>
            <th>{{'CURRENT_STATUS'| translate}}</th>
          </tr>
          <tr *ngFor="let val of overFlowPondData">
              <td>{{ val?.SNo }}</td>
              <td>{{ val?.Type }}</td>
              <td>{{ val?.Name }}</td>
              <td>{{ val?.Village }}</td>
              <td>{{ val?.District }}</td>
              <td>{{ val?.Block }}</td>
              <td>{{ val?.Constituency }}</td>
              <td>{{ val?.Division }}</td>
              <td><a *ngIf="val?.DocumentPath" style="cursor: pointer; color: 'blue'" [href]="val?.DocumentPath"
                target="_blank">{{'VIEW_DOC' | translate}}</a></td>
              <td>{{ val?.fromDate | date:'mediumDate' }}</td>
              <td>{{ val?.endDate | date:'mediumDate' }}</td>
              <td>{{ val?.CurrentStatus }}</td>
          </tr>
        </table> -->
    <br>
  </div>

  <div>
    <!-- <h5 style="color:rgb(22, 21, 21); background:darkseagreen;" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION3'| translate}}</b></h5> -->

    <p-table #table3 class="mainTable1" [value]="cropData" [rows]="5" [paginator]="false" [globalFilterFields]="[
        'SNo',
        'Type_Of_Crop_Name',
        'Crop_Name',
        'District',
        'fromDate',
        'endDate',
        ]" [rowHover]="true" sortMode="multiple" responsiveLayout="scroll" [loading]="loading"
      currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
      [showCurrentPageReport]="true">
      <ng-template pTemplate="caption">
        <div class="flex align-items-center justify-content-between">
          <h5 style="color:rgb(22, 21, 21)" class="px-3"><b>{{'NEW_TARGET_DESCRIPTION3'|
              translate}}</b></h5>
          <span class="p-input-icon-left">
            <!-- <i class="pi pi-search"></i> -->
            <input pInputText type="text" (input)="table3.filterGlobal($any($event.target).value, 'contains')"
              placeholder="{{'SEARCH'| translate}}" />
          </span>
        </div>
      </ng-template>

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="SNo">{{'SR_NO'| translate}}
            <!-- <p-columnFilter type="text" field="SNo" display="menu"></p-columnFilter>
            <p-sortIcon field="SNo"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Type_Of_Crop_Name">{{'CROP_TYPE'| translate}}
            <!-- <p-columnFilter type="text" field="Type_Of_Crop_Name" display="menu"></p-columnFilter>
            <p-sortIcon field="Type_Of_Crop_Name"></p-sortIcon> -->
          </th>
          <th pSortableColumn="Crop_Name">{{'CROP_NAME'| translate}}
            <!-- <p-columnFilter type="text" field="Crop_Name" display="menu"></p-columnFilter>
            <p-sortIcon field="Crop_Name"></p-sortIcon> -->
          </th>
          <th pSortableColumn="District">{{'DISTRICT'| translate}}
            <!-- <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
            <p-sortIcon field="District"></p-sortIcon> -->
          </th>
          <th pSortableColumn="fromDate">{{'START_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="fromDate" display="menu"></p-columnFilter>
            <p-sortIcon field="fromDate"></p-sortIcon> -->
          </th>
          <th pSortableColumn="endDate">{{'END_DATE'| translate}}
            <!-- <p-columnFilter type="text" field="endDate" display="menu"></p-columnFilter>
            <p-sortIcon field="endDate"></p-sortIcon> -->
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-product let-columns="columns">
        <tr>
          <td>{{product?.SNo}}</td>
          <td>{{product?.Type_Of_Crop_Name}}</td>
          <td>{{product?.Crop_Name}}</td>
          <td>{{product?.District}}</td>
          <td>{{product?.fromDate | date:'mediumDate'}}</td>
          <td>{{product?.endDate | date:'mediumDate'}}</td>
        </tr>
      </ng-template>
    </p-table>
    <!-- <table class="w3-border" style="border-collapse:separate;">
            <tr>
                <th>{{'SR_NO' | translate}}</th>
                <th>{{'CROP_TYPE' | translate}}</th>
                <th>{{'CROP_NAME' | translate}}</th>
                <th>{{'DISTRICT' | translate}}</th>
                <th>{{'START_DATE'| translate}}</th>
                <th>{{'END_DATE'| translate}}</th>
            </tr>
            <tr *ngFor="let val of cropData">
                <td>{{ val?.SNo }}</td>
                <td>{{ val?.Type_Of_Crop_Name }}</td>
                <td>{{ val?.Crop_Name }}</td>
                <td>{{ val?.District }}</td>
                <td>{{ val?.fromDate | date:'mediumDate' }}</td>
                <td>{{ val?.endDate | date:'mediumDate' }}</td>
            </tr>
        </table> -->
    <br>
  </div>
<!-- </div> -->